import { Helmet } from "react-helmet"

import React from "react"
import seoJson from "constants/seo-content.json";

function formatString(format, ...args) {
    let index = 0;
    return format.replace(/%s/g, () => {
        const arg = args[index++];
        return typeof arg !== 'undefined' ? arg : '';
    });
}

export default function SEO({ template, args }) {
 

    var seoObject = seoJson[template] || {};
    if (!args) args = [];
    //SEO Title
    var seoTitle = seoObject.title;

    seoTitle = formatString(seoTitle, args);

    //SEO Description
    var seoDescription = seoObject.description;

    seoDescription = formatString(seoDescription, args);


    var metaObject = {
        lang: "en",
        title: seoTitle || "",
        description: seoDescription || "",
        keywords: "",
        image: "https://tennisballcricket.com/apple-touch-icon.png",
        facebook: {
            title: seoTitle || "",
            url: "",
            description: seoDescription || "",
            image: "https://tennisballcricket.com/apple-touch-icon.png",
            site_name: "VisaGrader.com",
        },
        twitter: {
            title: seoTitle || "",
            large_image: "https://tennisballcricket.com/apple-touch-icon.png",
            description: seoDescription || "",
            image: "https://tennisballcricket.com/apple-touch-icon.png"
        }
    };
    return (
        <Helmet>

            <title>{metaObject.title}</title>
            <meta name="description"
                content={metaObject.description} />
            <meta name="robots" content="index, follow" />
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="language" content="English" />

            <meta property="og:locale" content="en_US" />
            <meta property="og:title" content={metaObject.facebook.title} />
            <meta property="og:url" content={metaObject.facebook.url} />
            <meta property="og:type" content="website" />
            <meta property="og:description" content={metaObject.facebook.description} />
            <meta property="og:image" content={metaObject.facebook.image} />
            <meta property="og:site_name" content={metaObject.facebook.sitename} />
            <meta property='article:author' content='https://www.facebook.com/tca' />



            <meta name="twitter:title" content={metaObject.twitter.title} />
            <meta name="twitter:card" content={metaObject.twitter.large_image} />
            <meta name="twitter:description"
                content={metaObject.twitter.description} />
            <meta name="twitter:image" content={metaObject.twitter.image} />
            <meta property="article:publisher" content="https://tennisballcricket.com" />
            <meta name="viewport" content="width=device-width" />

        </Helmet>
    )
};